document.addEventListener('DOMContentLoaded', function() {
  const mainMenu = document.querySelector('.menu-drawer__navigation > .menu-drawer__menu');
  const allDetails = document.querySelectorAll('.menu-drawer details');
  
  document.querySelectorAll('.submenu-toggle-icons').forEach(iconContainer => {
    const arrowIcon = iconContainer.querySelector('.icon-arrow-drawer, .icon-arrow');
    const minusIcon = iconContainer.querySelector('.icon-minus-drawer, .icon-minus');
    
    if (arrowIcon && minusIcon) {
      arrowIcon.style.display = 'block';
      minusIcon.style.display = 'none';
    }
  });
  
  allDetails.forEach(detail => {
    const summary = detail.querySelector('summary');
    const submenu = detail.querySelector('.menu-drawer__submenu');
    
    if (summary && submenu) {
      summary.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const isOpen = detail.hasAttribute('open');
        
        if (submenu.closest('.menu-drawer__submenu')) {
          const parentUl = detail.closest('ul');
          if (parentUl) {
            parentUl.querySelectorAll('details').forEach(otherDetail => {
              if (otherDetail !== detail && otherDetail.hasAttribute('open')) {
                otherDetail.removeAttribute('open');
                const otherSubmenu = otherDetail.querySelector('.menu-drawer__submenu');
                if (otherSubmenu) {
                  otherSubmenu.classList.remove('submenu-open');
                }
                
                const otherSummary = otherDetail.querySelector('summary');
                const iconContainer = otherSummary.querySelector('.submenu-toggle-icons');
                if (iconContainer) {
                  const otherArrow = iconContainer.querySelector('.icon-arrow-drawer, .icon-arrow');
                  const otherMinus = iconContainer.querySelector('.icon-minus-drawer, .icon-minus');
                  if (otherArrow && otherMinus) {
                    otherArrow.style.display = 'block';
                    otherMinus.style.display = 'none';
                  }
                }
              }
            });
          }
        }
        
        detail.toggleAttribute('open');
        
        const iconContainer = summary.querySelector('.submenu-toggle-icons');
        if (iconContainer) {
          const arrowIcon = iconContainer.querySelector('.icon-arrow-drawer, .icon-arrow');
          const minusIcon = iconContainer.querySelector('.icon-minus-drawer, .icon-minus');
          
          if (arrowIcon && minusIcon) {
            if (isOpen) {
              arrowIcon.style.display = 'block';
              minusIcon.style.display = 'none';
            } else {
              arrowIcon.style.display = 'none';
              minusIcon.style.display = 'block';
            }
          }
        }
        
        if (submenu.closest('.menu-drawer__submenu')) {
          const parentSubmenu = submenu.closest('.menu-drawer__inner-submenu');
          if (parentSubmenu) {
            parentSubmenu.style.height = 'auto';
          }
          
          submenu.classList.toggle('submenu-open');
        }
      });
    }
  });

  const backButtons = document.querySelectorAll('.menu-drawer__close-button');
  backButtons.forEach(button => {
    button.style.display = 'flex';
    button.style.alignItems = 'center';
    button.style.justifyContent = 'flex-start';
    
    button.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      const parentSubmenu = button.closest('.menu-drawer__submenu');
      if (parentSubmenu) {
        const parentDetails = parentSubmenu.closest('details');
        if (parentDetails) {
          parentDetails.removeAttribute('open');
          
          const summary = parentDetails.querySelector('summary');
          const iconContainer = summary.querySelector('.submenu-toggle-icons');
          if (iconContainer) {
            const arrowIcon = iconContainer.querySelector('.icon-arrow-drawer, .icon-arrow');
            const minusIcon = iconContainer.querySelector('.icon-minus-drawer, .icon-minus');
            
            if (arrowIcon && minusIcon) {
              arrowIcon.style.display = 'block';
              minusIcon.style.display = 'none';
            }
          }
        }
      }
    });
  });

  const mainDrawerDetails = document.getElementById('Details-menu-drawer-container');
  if (mainDrawerDetails) {
    mainDrawerDetails.addEventListener('close', () => {
      allDetails.forEach(detail => {
        if (detail !== mainDrawerDetails) {
          detail.removeAttribute('open');
          
          const summary = detail.querySelector('summary');
          const iconContainer = summary?.querySelector('.submenu-toggle-icons');
          if (iconContainer) {
            const arrowIcon = iconContainer.querySelector('.icon-arrow-drawer, .icon-arrow');
            const minusIcon = iconContainer.querySelector('.icon-minus-drawer, .icon-minus');
            
            if (arrowIcon && minusIcon) {
              arrowIcon.style.display = 'block';
              minusIcon.style.display = 'none';
            }
          }
        }
      });
    });
  }
});